export default {"src":"/_next/static/media/sdt.c37b0b67.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};